export default function setPredefinedCookieValues({ state }) {
  let client = state.get('client')
  Object.keys(client.busPredefined).forEach(key => {
    Object.keys(client.busPredefined[key]).forEach(fieldKey => {
      let cookieData = client.busPredefined[key][fieldKey]
      if (key === 'common' || key === 'aggregations') {
        let stateField = client.registrating.current.common[fieldKey]
        mergeCookieValue(
          state,
          cookieData,
          stateField,
          `client.registrating.current.common.${fieldKey}`
        )
      }
      if (key === 'registration') {
        client.addresstypes.forEach(type => {
          let stateField = client.registrating.current[type][fieldKey]
          mergeCookieValue(
            state,
            cookieData,
            stateField,
            `client.registrating.current.${type}.${fieldKey}`
          )
        })
      }
    })
  })
}

/**
 * a field can look like this
{
  type: 'select',
  options: [{
    condition: '1',
    value: 'Sweden',
    key: 'sweden'
  }]
}
* cookie can look like this
busPredefined: {
  common: {
    username: {
      hidden: false,
      hideForAdmins: false,
      value: "Mary Kay"
    }
   },
  aggregations: {
    shop: {
      hidden: false,
      condition: "1"
    },
    Country: {
      hidden: false,
      value: "NO"
    }
  }
}
*/
function mergeCookieValue(state, cookieData, field, path) {
  let {
    hidden = false,
    hideForAdmins = false,
    value = '',
    condition
  } = cookieData
  let defaultHidden = hidden
  if (field) {
    if (field.type === 'text') {
      state.merge(path, {
        hidden,
        defaultHidden,
        hideForAdmins,
        value,
        defaultValue: value
      })
    }
    if (field.type === 'select') {
      let selectedValue = []
      let options = field.options
        .filter(option => {
          if (condition) {
            if (!option.condition) return false
            return option.condition.indexOf(condition) > -1
          }
          return true
        })
        .map((option, index) => {
          let currentOption = {
            i18nKey: option.i18nKey,
            value: option.value,
            key: option.key,
            index: index,
            selected: option.key === value
          }
          if (value !== '') {
            if (option.key === value) {
              selectedValue = [currentOption]
            }
          }
          return currentOption
        })
      state.merge(path, {
        hidden,
        hideForAdmins,
        value: selectedValue,
        defaultValue: selectedValue,
        options
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/actions/setPredefinedCookieValues.js